import { Container, Grid, Card, Link } from '@postenbring/hedwig-react'

export const MagazineCards = ({ cards, readMore }) => (
    <Container asChild>
        <Grid gap="20-24" span={{ initial: 12, large: 6, xlarge: 4 }}>
            {cards.map(({ imgUrl, title, description, url, overline }) => (
                <Card variant='slim' key={`${url}-${overline}`}>
                    {imgUrl && (
                        <Card.Media>
                            <Card.MediaImg src={imgUrl} />
                        </Card.Media>
                    )}
                    <Card.Body>
                        {(title || overline) && (
                            <Card.BodyHeader as="h3">
                                {overline && <Card.BodyHeaderOverline>{overline}</Card.BodyHeaderOverline>}
                                {title && <Card.BodyHeaderTitle>{title}</Card.BodyHeaderTitle>}
                            </Card.BodyHeader>
                        )}
                        {description && <Card.BodyDescription>{description}</Card.BodyDescription>}
                        {url && (
                            <Card.BodyAction asChild>
                                <Link href={url} variant='solid'>
                                    <Card.BodyActionArrow />
                                    {readMore}
                                </Link>
                            </Card.BodyAction>
                        )}
                    </Card.Body>
                </Card>
            ))}
        </Grid>
    </Container>
)
